import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'wsb-ui-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CardComponent {
  @Input() public title: string;
  @Input() public subtitle: string;
  @Input() public type: string;

  constructor() {}
}
